import { render, staticRenderFns } from "./profiledit.vue?vue&type=template&id=5587d5ee&"
import script from "./profiledit.vue?vue&type=script&lang=js&"
export * from "./profiledit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports